import gql from 'graphql-tag';

export const GET_JOB_DETAILS = gql`
  query GetJobDetails(
    $jobId: ID!
    $jobDetailsViewedCorrelationId: String!
    $sessionId: String!
    $zone: Zone!
    $locale: Locale!
    $languageCode: LanguageCodeIso!
    $countryCode: CountryCodeIso2!
    $timezone: Timezone!
  ) {
    jobDetails(
      id: $jobId
      tracking: {
        channel: "WEB"
        jobDetailsViewedCorrelationId: $jobDetailsViewedCorrelationId
        sessionId: $sessionId
      }
    ) {
      job {
        tracking {
          adProductType
          classificationInfo {
            classificationId
            classification
            subClassificationId
            subClassification
          }
          hasRoleRequirements
          isPrivateAdvertiser
          locationInfo {
            area
            location
            locationIds
          }
          workTypeIds
          postedTime
        }
        id
        title
        phoneNumber
        isExpired
        isLinkOut
        contactMatches {
          type
          value
        }
        isVerified
        abstract
        content(platform: WEB)
        status
        listedAt {
          label(
            context: JOB_POSTED
            length: SHORT
            timezone: $timezone
            locale: $locale
          )
        }
        salary {
          currencyLabel(zone: $zone)
          label
        }
        shareLink(platform: WEB, zone: $zone, locale: $locale)
        workTypes {
          label(locale: $locale)
        }
        advertiser {
          id
          name(locale: $locale)
        }
        location {
          label(locale: $locale, type: LONG)
        }
        classifications {
          label(languageCode: $languageCode)
        }
        products {
          branding {
            id
            cover {
              url
            }
            thumbnailCover: cover(isThumbnail: true) {
              url
            }
            logo {
              url
            }
          }
          bullets
          questionnaire {
            questions
          }
          video {
            url
            position
          }
        }
      }
      companyReviews(zone: $zone) {
        id
        name
        fullName
        rating
        reviewCount
        reviewsUrl
      }
      companySearchUrl(zone: $zone, languageCode: $languageCode)
      learningInsights(platform: WEB, zone: $zone, locale: $locale) {
        analytics
        content
      }
      companyTags {
        key(languageCode: $languageCode)
        value
      }
      restrictedApplication(countryCode: $countryCode) {
        label(locale: $locale)
      }
      sourcr {
        image
        imageMobile
        link
      }
    }
  }
`;

export const GET_JOB_DETAILS_PERSONALISED = gql`
  query GetJobDetailsPersonalised(
    $id: ID!
    $tracking: JobDetailsTrackingInput
    $locale: Locale!
    $zone: Zone!
  ) {
    jobDetails(id: $id, tracking: $tracking) {
      personalised {
        isSaved
        appliedDateTime {
          longAbsoluteLabel(locale: $locale)
        }
        topApplicantBadge {
          label(locale: $locale)
          description(locale: $locale, zone: $zone)
        }
      }
    }
  }
`;

export const GET_JOB_DETAILS_WITH_PERSONALISED = gql`
  query GetJobDetailsWithPersonalised(
    $jobId: ID!
    $jobDetailsViewedCorrelationId: String!
    $sessionId: String!
    $zone: Zone!
    $locale: Locale!
    $languageCode: LanguageCodeIso!
    $countryCode: CountryCodeIso2!
    $timezone: Timezone!
  ) {
    jobDetails(
      id: $jobId
      tracking: {
        channel: "WEB"
        jobDetailsViewedCorrelationId: $jobDetailsViewedCorrelationId
        sessionId: $sessionId
      }
    ) {
      personalised {
        isSaved
        appliedDateTime {
          longAbsoluteLabel(locale: $locale)
        }
        topApplicantBadge {
          label(locale: $locale)
          description(locale: $locale, zone: $zone)
        }
      }
      job {
        tracking {
          adProductType
          classificationInfo {
            classificationId
            classification
            subClassificationId
            subClassification
          }
          hasRoleRequirements
          isPrivateAdvertiser
          locationInfo {
            area
            location
            locationIds
          }
          workTypeIds
          postedTime
        }
        id
        title
        phoneNumber
        isExpired
        isLinkOut
        isVerified
        contactMatches {
          type
          value
        }
        abstract
        content(platform: WEB)
        status
        listedAt {
          label(
            context: JOB_POSTED
            length: SHORT
            timezone: $timezone
            locale: $locale
          )
        }
        salary {
          currencyLabel(zone: $zone)
          label
        }
        shareLink(platform: WEB, zone: $zone, locale: $locale)
        workTypes {
          label(locale: $locale)
        }
        advertiser {
          id
          name(locale: $locale)
        }
        location {
          label(locale: $locale, type: LONG)
        }
        classifications {
          label(languageCode: $languageCode)
        }
        products {
          branding {
            id
            cover {
              url
            }
            thumbnailCover: cover(isThumbnail: true) {
              url
            }
            logo {
              url
            }
          }
          bullets
          questionnaire {
            questions
          }
          video {
            url
            position
          }
        }
      }
      companyReviews(zone: $zone) {
        id
        name
        fullName
        rating
        reviewCount
        reviewsUrl
      }
      companySearchUrl(zone: $zone, languageCode: $languageCode)
      learningInsights(platform: WEB, zone: $zone, locale: $locale) {
        analytics
        content
      }
      companyTags {
        key(languageCode: $languageCode)
        value
      }
      restrictedApplication(countryCode: $countryCode) {
        label(locale: $locale)
      }
      sourcr {
        image
        imageMobile
        link
      }
    }
  }
`;
